import { Component, OnDestroy, OnInit } from '@angular/core';
import { Log } from "ng2-logger";
import { ToolReturn } from "@models/tool-return.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { Subscription } from "rxjs";
import { ToolReturnsService } from "@services/tool-returns.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "@services/notification.service";
import { TranslateService } from "@ngx-translate/core";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { Section } from "@models/enums/section.utils";
import { AppUtils } from "@app/shared/util/app.utils";

@Component({
    selector: 'app-tool-returns-facilities',
    templateUrl: './tool-returns-facilities.component.html',
    styleUrls: ['./tool-returns-facilities.component.scss']
})
export class ToolReturnsFacilitiesComponent implements OnInit, OnDestroy {

    _logger = Log.create(ToolReturnsFacilitiesComponent.name);

    toolReturns: ToolReturn[] = [];
    tableConfig = new TableConfig();
    isLoading = false;

    newFacilitiesToolReturnSubscription: Subscription;
    selectedPlantsChangedSubscription: Subscription;

    filterStatusList = [
        {name: 'WaitingForApproval'},
        {name: 'Approved'},
    ];

    basePath = 'tool-returns-facilities';

    constructor(private toolReturnsService: ToolReturnsService,
                private router: Router,
                private translateService: TranslateService,
                private notificationService: NotificationService,
                private route: ActivatedRoute) {

        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
        });

        this.selectedPlantsChangedSubscription = this.notificationService.selectedPlantsChangedAsObservable.subscribe(data => {
            this.getToolReturns(this.tableConfig);
        });
    }

    ngOnInit() {
        this.getToolReturns(this.tableConfig);
        this.newFacilitiesToolReturnSubscription = this.notificationService.facilitiesToolReturnsQueueObservable.subscribe((value) => {
            if (value) {
                this._logger.info("ngOnInit:: toolReturnsQueueSubscription got value", value);
                this.getToolReturns(this.tableConfig);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.newFacilitiesToolReturnSubscription) {
            this.newFacilitiesToolReturnSubscription.unsubscribe();
        }

        if (this.selectedPlantsChangedSubscription) {
            this.selectedPlantsChangedSubscription.unsubscribe();
        }
    }

    getToolReturns(tableConfig = this.tableConfig) {
        this._logger.info('getToolReturns:: Retrieving tool returns ');
        this.isLoading = true;
        tableConfig = AppUtils.appendPlantsQuery(tableConfig);
        this.toolReturnsService.getAllToolReturns(tableConfig, 'TICKET', Section.ApproveToolReturns).subscribe(
            (data) => {
                this._logger.info('getToolReturns:: API Returned data', data);
                this.toolReturns = data.items;
                this.tableConfig.pager.count = data.total;
                this.isLoading = false;
            },
            (error) => {
                this._logger.error('getToolReturns:: API Returned error', error);
                this.isLoading = false;
            }
        )
    }

    onSortChange(tableState) {
        this.getToolReturns(tableState);
    }

    onFilter(tableConfig: TableConfig) {
        this.getToolReturns(tableConfig);
    }

    onPageChange(tableConfig: TableConfig) {
        this.getToolReturns(tableConfig);
    }

    onActionClick(action: any) {
        if (action.startProcess) {
            this.toolReturnsService.processToolReturn(action.toolReturn).subscribe(
                (data) => {
                    this._logger.info('processToolReturn:: API Returned data', data);
                },
                (error) => {
                    this._logger.error('processToolReturn:: API Returned error', error);
                }
            );
        }
        this.router.navigate([`${this.basePath}/${action.toolReturn.id}`]);
    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.statuses.approved"),
                value: ToolRequestStatus.APPROVED
            },
            {
                name: this.translateService.instant("generic.statuses.waitingForProcessing"),
                value: ToolRequestStatus.WAITING_FOR_PROCESSING
            },
        ];
    }
}
